import { useMutation } from '@apollo/client';

import {
  IRedeemBookingRequest,
  IRedeemBookingResponse,
  REDEEM_BOOKING,
} from 'schemas';

import { TRedeemBooking } from './interfaces';
import { HOSTS_DATA } from './useHostsData/schema';

export const useRedeemBooking = (): TRedeemBooking => {
  const [redeemBooking] = useMutation<
    IRedeemBookingResponse,
    IRedeemBookingRequest
  >(REDEEM_BOOKING, {
    refetchQueries: [HOSTS_DATA],
    awaitRefetchQueries: true,
  });

  return redeemBooking;
};
